module.exports = __webpack_public_path__ + "img/secton4.68574012.png";